import t from "./index267.js";
import { resolveComponent as s, createBlock as r, openBlock as a, resolveDynamicComponent as l, mergeProps as i, withCtx as f, createCommentVNode as n, renderSlot as d, normalizeClass as m } from "vue";
import p from "./index231.js";
function u(e, h, g, k, P, c) {
  const o = s("ms-arrow-right");
  return a(), r(l(e.isPRG ? "span" : "a"), i({
    class: ["flex font-bold transition-colors duration-200 cursor-pointer text-text-l hover:underline ease-ms", {
      "text-color-brand-beige-200 pointer-events-none": e.isDisabled,
      "after:absolute after:top-0 after:left-0 after:bottom-0 after:right-0": e.hasClickArea
    }],
    href: e.isPRG ? null : e.href,
    target: e.isPRG ? null : e.target,
    rel: !e.isPRG && e.rel ? e.rel : null,
    "data-component": e.$options.name,
    "data-mod": e.isPRG ? "prg" : null,
    "data-prg-href": e.isPRG ? e.href : null,
    "data-sign": e.isPRG ? e.sign : null,
    "data-target": e.isPRG ? e.target : null
  }, e.trackingId), {
    default: f(() => [
      e.isSuffixIcon ? n("", !0) : (a(), r(o, {
        key: 0,
        class: m(["flex-shrink-0 w-24 h-24 mr-8", e.hasAnchorIcon ? "rotate-90" : null])
      }, null, 8, ["class"])),
      d(e.$slots, "default"),
      e.isSuffixIcon ? (a(), r(o, {
        key: 1,
        class: "flex-shrink-0 w-24 h-24 ml-8"
      })) : n("", !0)
    ]),
    _: 3
  }, 16, ["class", "href", "target", "rel", "data-component", "data-mod", "data-prg-href", "data-sign", "data-target"]);
}
const b = /* @__PURE__ */ p(t, [["render", u]]);
export {
  b as default
};
